import React from 'react';
import '../../styles/picker.css';

/**
 * 入力欄 + 📅アイコン。📅クリック（または Enter/Space）でカレンダーを開く。
 * props は react-datepicker から渡される value / onClick に加え placeholder を任意で受ける。
 */
interface CalenderInputProps {
  value: string;
  onClick: () => void;
  placeholder?: string;
  className?: string;
}

const CalendarInput = React.forwardRef<HTMLInputElement, CalenderInputProps>(
  function CalendarInput({ value, onClick, placeholder, className }, ref) {
    return (
      <div className="input-group">
        <input
          ref={ref}
          className={`form-control ${className ?? ''}`}
          value={value}
          readOnly
          placeholder={placeholder}
          onClick={onClick}
        />
      </div>
    );
  }
);

export default CalendarInput;
